// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { commonShortNouns } from "./common-short-fields";

export const platformAdminAssetsObjectSpaces = {
  columns: {
    displayName: "表示名",
    writePolicy: "書込権限",
    status: commonShortNouns.status,
    assetCount: "アセット数",
    capacity: "容量",
    quota: "容量上限",
    latestWrite: "最新書込",
    granteeType: "付与先種別",
    grantee: "付与先",
    accessLevel: "権限",
  },
  actions: {
    createSpacePolicy: "オブジェクト空間を統治",
    editPolicy: "書込権限を編集",
    onboardGovernance: "統治へ編入",
    grant: "権限付与",
    createGrant: "付与を追加",
    removeGrant: "削除",
  },
  drawer: {
    assetGovernance: "アセット統治詳細 · {name}",
    assetGovernanceShort: "アセット統治詳細",
    deleteProtection: "削除保護",
    references: "参照詳細",
    referencesSubtitle:
      "アセット参照の真相は asset-center から直接取得し、業務側では推導しません。",
    grantTitle: "オブジェクト空間権限 · {name}",
    grantTitleShort: "オブジェクト空間権限",
    grantSummary: "権限概要",
    grantRules: "権限ルール",
  },
  objects: {
    objectSpaceGrant: "オブジェクト空間権限",
  },
  fields: {
    deleteStatus: "削除状態",
    referenceCount: "参照数",
    businessReferenceCount: "業務参照数",
    businessReferenceSnapshotCount: "履歴ソースヒント",
    objectSpace: "オブジェクト空間",
    quota: "容量上限",
    storageBackend: "保存先",
    spacePolicy: "書込権限",
    spaceStatus: "空間状態",
    grantCount: "権限数",
    blockingReasons: "阻止理由",
    governanceWarnings: "統治警告",
  },
  form: {
    objectSpacePolicyTitle: "オブジェクト空間統治 · {name}",
    objectSpacePolicyCreate: "オブジェクト空間を統治",
    objectSpaceKey: "オブジェクト空間キー",
    objectSpaceKeyRequired: "オブジェクト空間キーを入力してください",
    displayName: "表示名",
    scopeType: "スコープ種別",
    scopeTypeRequired: "スコープ種別を選択してください",
    scopeValue: "スコープ値",
    scopeValueRequired: "スコープ値を入力してください",
    writePolicy: "書込権限",
    writePolicyRequired: "書込権限を選択してください",
    quotaGb: "空間容量上限",
    quotaGbPlaceholder: "空欄なら無制限",
    quotaGbHelp: "このオブジェクト空間の総容量上限を GB 単位で設定します。空欄なら無制限です。",
    status: commonShortNouns.status,
    statusRequired: "状態を選択してください",
    grantCreateTitle: "オブジェクト空間権限を追加 · {name}",
    grantCreateTitleShort: "オブジェクト空間権限を追加",
    grantTargetType: "付与先種別",
    grantTargetTypeRequired: "付与先種別を選択してください",
    grantTarget: "付与先",
    grantTargetRequired: "付与先を入力してください",
    accessLevel: "権限レベル",
    accessLevelRequired: "権限レベルを選択してください",
    removeGrantTitle: "権限を削除",
    removeGrantDescription: "{type}:{value} を削除しますか？",
    noSelectedSpace: "オブジェクト空間が選択されていません",
  },
  errors: {
    partialLoadFailed:
      "アセットセンターデータの一部読取に失敗しました（{count} 件の要求が成功しませんでした）",
    grantLoadFailed: "オブジェクト空間権限の読取に失敗しました",
    grantRemoveFailed: "オブジェクト空間権限の削除に失敗しました",
    policyUpdateFailed: "オブジェクト空間方針の更新に失敗しました",
    policyCreateFailed: "オブジェクト空間方針の作成に失敗しました",
    grantCreateFailed: "オブジェクト空間権限の作成に失敗しました",
  },
} as const;
